import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { AuthService } from '@scripts/woo_services.module/AuthService';
import { WooSystemSettingsModule } from '@scripts/woo_system_settings.module/module';
import { WooTabComponent } from '@src/shared/navigation/woo-tabs/woo-tab/woo-tab.component';
import { WooTabsComponent } from '@src/shared/navigation/woo-tabs/woo-tabs.component';

@Component({
  selector: 'system-settings',
  templateUrl: './system-settings.component.html',
  imports: [CommonModule, WooTabsComponent, WooTabComponent, WooSystemSettingsModule],
})
export class SystemSettings {
  private readonly auth = inject(AuthService);

  readonly isAdmin = this.auth.admin();
  readonly isAdminOrPlanner = this.auth.adminOrPlanner();
}
